import React, { useEffect, useState } from 'react'
import style from "./DocumentType.module.css"
import styles from "./CreateDocument.module.css";
import Breadcrumb from '../../components/Verifier/breadcrumb/BreadCrumb';
import IssuerNavigator from '../../components/DashBoard/IssuerNavigator';
import { Icon } from 'react-icons-kit';
import { arrow_right } from 'react-icons-kit/ikons/arrow_right';

import { GET_MASTER_DOCUMENTS, GLOBAL_NAME_TEMPLATE, REGISTER_DOCUMENT } from '../../Utils/constant';
import API from '../../ApiConfig';
import Loader from '../../components/Loader';
import { useLocation, useNavigate } from 'react-router-dom';
import cogoToast from 'cogo-toast-react-17-fix';
import { AuthConsole, isInternalUser } from '../../Utils/helper';
import Modal from '../../Utils/Modal';
import { useSelector } from 'react-redux';
const DocumentType = ({ id }) => {

    const [loading, setLoading] = useState(false)
    const [templateType, setTemplateType] = useState(Array(7).fill().map((_, index) => index + 1));
    const [Popup, setPopUp] = useState(false)
    const [selectedDocumentName, setSelectedDocumentName] = useState(null)
    const location=useLocation();
    
    const User=useSelector(state=>state.User)
    let isInternal = isInternalUser()
    let navigateBack = "/dashboard/mydocuments"
    if (isInternal) {
        navigateBack = "/dashboard/mydocuments"
    }

    const navigate = useNavigate();
    useEffect(() => {
        setLoading(true)
        API.get(GET_MASTER_DOCUMENTS)
            .then(data => {
                setLoading(false)
                let res = data.data
                setTemplateType(res.data)
            })
            .catch(err => {
                setLoading(false)
                cogoToast.error(err.message)
            })
    }, [])

    const useTemplate = () => {

        const handleNavigate = (link) => {
            navigate(link)
        }
        return (

            <div className="navItemContainer">
            </div>
        )
    }
    const NavigateToTagMapping = (e, name) => {
        if(User.user_type=="Issuer") {
            e.preventDefault()
            setLoading(true)
            let formData = [{
                issuer_id: id,
                doc_name: name
            }]
            API.post(REGISTER_DOCUMENT, formData)
                .then(data => {
                    if (data.data.status == 200) {
                        if (data.data.data == "") {
                            setLoading(false)
                            cogoToast.info("Could not add before completing the previous one")
                        }
                        else {
                            setLoading(false)
                            cogoToast.success("Document Added")
                            navigate('/Create/' + data.data.data[0].id + "/Mapping")
                        }
                    }
                })
                .catch(err => {
                    setLoading(false);
                    AuthConsole(err);

                })
        }
        else if(isInternal) {
            e.preventDefault()
            setPopUp(true)
            setSelectedDocumentName(name)
        }
    }


    const handleGlobalTemplate = (e, originalName, newValue) => {
        e.preventDefault();
        setLoading(true);
        API.get(GLOBAL_NAME_TEMPLATE + `?name=${newValue}&doc_name=${originalName}`)
            .then(res => {
                if (res.data.status == 200) {
                    setLoading(false)
                    setPopUp(false)
                    navigate('/Create/' + res?.data?.data?.id + "/Mapping")
                    // console.log(res);
                }
            })
            .catch(err => {
                setPopUp(false)
                setLoading(false)
                cogoToast.error(err?.response?.data?.message || "An error occured")
                AuthConsole(err);

            })
    }
    const DocName = ({ originalName }) => {
        AuthConsole(originalName);

        const [customName, setcustomName] = useState('')
        return (
            <>
                <div style={{ padding: "1rem" }}>
                    <div>Please enter the document name</div>
                    <input type='text' placeholder='Document Name' value={customName} className={style.DocName} onChange={e => setcustomName(e.target.value)} />
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <button className='btn btn-primary' style={{ width: "50%" }} onClick={(e) => handleGlobalTemplate(e, originalName, customName)}>Enter Name</button>
                    </div>
                </div>
            </>
        )
    }
    const updatePopup = (bool) => {
        setPopUp(bool);
    }
    return (
        <div style={{width:"100%"}}>
            <Loader isOpen={loading} />
            {
                !isInternal && <>
                    <Breadcrumb title={"Create New Template"} pos={2} category={"template"} />

                    <IssuerNavigator
                        title={"Choose document type"}
                        step={"/dashboard/mydocuments"}
                        actions={useTemplate} />
                </>
            }

            <div className={style.docType}>
                {templateType.map((item => (
                    loading ? [...Array(1)].map((_, index) => <div className={style.docTypeList}> <div className="shimmer" style={{ height: "5rem" }}></div></div>) :



                        <div className={style.docTypeList} key={item.id} onClick={(e) => NavigateToTagMapping(e, item.name)}>
                            <div className={style.documentOption}>
                                <div className={style.documentIcon}>
                                    <img src={item.icon} />
                                </div>
                                <div className={style.docname}>
                                    <div className={style.documentTitle}>
                                        {item.name}
                                    </div>
                                    {/* <div className={style.documentSubText}> {item.name} </div> */}
                                </div>
                            </div>
                            <div>
                                <Icon icon={arrow_right} />
                            </div>
                        </div>
                )))}
            </div>
            <Modal title={"Enter Document Name"} isOpen={Popup} onClose={updatePopup} blockOutsideClick={true} children={<DocName originalName={selectedDocumentName} />} />
        </div>
    )
}

export default DocumentType;